import React from 'react'

const Controls = (props) => {
	return (
		<div style={{ color: '#f00', position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', zIndex: '2'}}>controls</div>
	)
}

export default Controls


// WEBPACK FOOTER //
// ./src/desktop/components/video-player/controls.js